import React, {Component} from "react";
import Expander from "./Expander";
import TagsTreeView from "./TagsTreeView";
import { strings } from "../localization";

export default class TagsTreeViewDropDown extends Component {

    componentDidUpdate(prevProps) {
        if (prevProps.clearFilterTags !== this.props.clearFilterTags) {
            this.clearSelecedTags();
        }
    }

    createDropdownLabel = () => {

        const { tags, selectedTagsIds, placeholder } = this.props;
        
        switch (selectedTagsIds.length) {
            case 0:
                return placeholder ? placeholder : "";
            case 1:
                const tag = tags.find(t => t.tagId === selectedTagsIds[0]);
                return tag.name;
            default:
                return strings.formatString(strings.custom_dropdown_x_selected, selectedTagsIds.length);
        }
    }

    clearSelecedTags = () => {
        this.props.onChange([]);
        if (this.props.clearFilterTags) {
            this.props.resetClearFilterTags();
        }
    }

    render() {
        
        const showClearButton = this.props.showClearButton !== undefined ? this.props.showClearButton : this.props.selectedTagsIds.length > 0 && !this.props.required;
        
        return (
            <Expander
                className={this.props.className}
                label={this.createDropdownLabel()}
                showClearButton={showClearButton}
                showPlaceholder={this.props.selectedTagsIds.length === 0}
                useReactSelectComponent={this.props.useReactSelectComponent}
                onClear={this.clearSelecedTags}
                onOpen={this.props.onOpen}
                onClose={this.props.onClose}
                isOpen={this.props.isOpen}
                showCloseButton={true}
            >
                <TagsTreeView {...this.props} />
            </Expander>
        );
    }
}